export const getPwsIdCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)PWS_ID=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const setPwsIdCookie = (pwsId) => {
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 10);
  document.cookie = `PWS_ID=${encodeURIComponent(pwsId)}; expires=${expires.toUTCString()}; path=/`;
};
